import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { 
    fetchOffersByVendor, 
    fetchOffersByCategory, 
    fetchOffersByPage, 
    SERVER_BASE_URL 
} from '../api/thamanService';
import Loader from '../components/Loader';
import ErrorMessage from '../components/ErrorMessage';
import OfferDetailModal from '../components/OfferDetailModal'; // 1. Import the new modal

export default function OffersListPage() {
    const [offers, setOffers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [title, setTitle] = useState('');

    // --- NEW STATE for the modal ---
    const [selectedOfferId, setSelectedOfferId] = useState(null);
    // -----------------------------

    const { vendorId, categoryId, pageId } = useParams();

    useEffect(() => {
        // ... (This getOffers function remains exactly the same)
        const getOffers = async () => {
            try {
                setError(null);
                setIsLoading(true);
                let data;
                if (vendorId) { setTitle(`Offers for Vendor #${vendorId}`); data = await fetchOffersByVendor(vendorId); } 
                else if (categoryId) { setTitle(`Offers in Category #${categoryId}`); data = await fetchOffersByCategory(categoryId); } 
                else if (pageId) { setTitle(`Offers on Page #${pageId}`); data = await fetchOffersByPage(pageId); }
                setOffers(data);
            } catch (err) {
                setError('Failed to fetch offers.');
            } finally {
                setIsLoading(false);
            }
        };
        getOffers();
    }, [vendorId, categoryId, pageId]);

    return (
        <div>
            <h1 className="text-3xl font-bold mb-6">{title}</h1>

            {isLoading && <Loader message="Fetching offers..." />}
            {error && <ErrorMessage message={error} />}

            {!isLoading && !error && (
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {offers.length > 0 ? (
                        offers.map(offer => (
                            // 2. Make the offer card clickable by adding an onClick handler
                            <div key={offer.id} className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer hover:shadow-xl transition-shadow" onClick={() => setSelectedOfferId(offer.id)}>
                                <img 
                                    src={offer.item_image_path ? `${SERVER_BASE_URL}${offer.item_image_path}` : 'https://placehold.co/400x300?text=No+Image'} 
                                    alt={offer.english_name} 
                                    className="w-full h-48 object-cover" 
                                    onError={(e) => { e.target.onerror = null; e.target.src='https://placehold.co/400x300?text=Image+Missing' }}
                                />
                                <div className="p-4">
                                    <h3 className="font-bold">{offer.english_name}</h3>
                                    <p className="text-sm text-gray-600">{offer.arabic_name}</p>
                                    <p className="text-lg font-semibold text-red-600 mt-2">{offer.current_price} {offer.currency}</p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="col-span-full text-center text-gray-500 py-4">No offers found for this selection.</p>
                    )}
                </div>
            )}

            {/* 3. Render the modal component */}
            <OfferDetailModal 
                offerId={selectedOfferId}
                onClose={() => setSelectedOfferId(null)} // Closing the modal just clears the selected ID
            />
        </div>
    );
}